// Details
export const GET_WORKSHOP_DETAILS_REQUEST = "GET_WORKSHOP_DETAILS_REQUEST";
export const GET_WORKSHOP_DETAILS_SUCCESS = "GET_WORKSHOP_DETAILS_SUCCESS";
export const GET_WORKSHOP_DETAILS_FAILURE = "GET_WORKSHOP_DETAILS_FAILURE";
export const RESET_WORKSHOP_DETAILS = "RESET_WORKSHOP_DETAILS";